import { ReactElement } from 'react';
import { useRoutes, Link } from 'react-router-dom';
import { CreateScene, DeleteScene, EntityScene, ModelScene, IndexScene, UpdateScene, useEntity } from 'components';
import { FactorRateBadge } from 'modules/supplier/factors';
import { Icon } from '@ff-it/ui';
import { ControlledTableColumns, flexColumn } from 'components/ControlledTable';
import { VendorFactor } from 'modules/supplier/factors/types';
import { VendorFactorForm } from 'modules/supplier/factors/VendorFactorForm';
import permissions from 'modules/supplier/vendor/permissions';
import { initialFactorValues } from 'modules/supplier/factors/initialValues';

const columns: ControlledTableColumns<VendorFactor> = [
  flexColumn({
    content: 'Name',
    key: 'name',
    required: true,
    sortable: true,
    render: ({ id, name, auto_apply }: VendorFactor) => (
      <>
        <Link to={`${id}`}>{name}</Link>
        {auto_apply && <Icon icon="bolt-auto" ml="1" />}
      </>
    ),
  }),
  flexColumn({
    content: 'Description',
    key: 'description',
  }),
  {
    content: 'Kind',
    key: 'kind',
    width: 100,
  },
  {
    content: 'Form',
    key: 'form',
    width: 100,
  },
  {
    content: 'Rate',
    key: 'rate',
    width: 100,
    cellProps: { textAlign: 'right' },
    render: (factor) => <FactorRateBadge factor={factor} />,
  },
];

export function Factors(): ReactElement {
  const { endpoint } = useEntity();
  const url = `${endpoint}factors/`;

  const routes = useRoutes([
    {
      index: true,
      element: <IndexScene columns={columns} />,
    },
    {
      path: 'create',
      element: (
        <CreateScene initialValues={initialFactorValues}>
          <VendorFactorForm />
        </CreateScene>
      ),
    },
    {
      path: ':id/',
      element: <EntityScene />,
      children: [
        {
          index: true,
          element: (
            <UpdateScene>
              <VendorFactorForm />
            </UpdateScene>
          ),
        },

        {
          path: 'delete',
          element: <DeleteScene />,
        },
      ],
    },
  ]);
  return (
    <ModelScene
      endpoint={url}
      title="Factor"
      pluralTitle="Factors"
      entityTitle={({ name }: VendorFactor) => name}
      permissions={permissions}
    >
      {routes}
    </ModelScene>
  );
}
